import React from 'react';
import url from 'url';

const NO_SANDBOX_HOSTS: string[] = ['www.youtube.com'];

interface IFrameAttachmentProps {
  iframeUrl: string;
}

const IFrameAttachment: React.FC<IFrameAttachmentProps> = ({ iframeUrl }) => {
  if (!iframeUrl) {
    return null;
  }

  const host = url.parse(iframeUrl).hostname;
  const shouldSandbox = !host || !NO_SANDBOX_HOSTS.includes(host);

  return (
    <div className="container">
      <iframe
        width="560"
        height="315"
        src={iframeUrl}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        sandbox={shouldSandbox ? '' : undefined}
      ></iframe>
    </div>
  );
};

export default IFrameAttachment;
